import { Kind, OperationTypeNode } from "graphql";
// Function to extract root query field name from GraphQL query
export default function extractRootResolver(operation) {
    const operationDefintion = operation.query.definitions.find(definition => definition.kind === Kind.OPERATION_DEFINITION &&
        [OperationTypeNode.MUTATION, OperationTypeNode.QUERY].includes(definition.operation));
    if (!operationDefintion) {
        return null;
    }
    const selection = operationDefintion.selectionSet.selections[0];
    if (selection.kind !== Kind.FIELD) {
        return null;
    }
    return {
        operationType: operationDefintion.operation,
        operationName: selection.name.value,
    };
}
;
